import { Link } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBolt, faLock, faComment } from '@fortawesome/free-solid-svg-icons'
import FrontHeader from '../components/FrontHeader'
import FrontFooter from '../components/FrontFooter'

function Forex() {
  return (
    <div>
      <div style={{backgroundColor: 'rgb(5, 8, 11)', position: 'relative', paddingBottom: '8rem'}}>
        <div className="position-absolute top-0 left-0 w-100 h-100 bg-black opacity-50" style={{zIndex: '10'}}></div>
        <FrontHeader/>
        <div className="container position-relative" style={{zIndex: '12', paddingTop: '8rem'}}>
            <div className="mx-auto" style={{maxWidth: '56rem'}}>
                <h1 className="text-white fw-bold mb-4 text-center font-large" style={{lineHeight: '1.1'}}>Trade foreign exchange on our platform</h1>
                <p style={{fontSize: '18px'}} className='mb-5 text-center'>Forex is short for foreign exchange. The forex market is a place where currencies are traded. It is the largest and most liquid financial market in the world with an average daily turnover of 6.6 trillion U.S. dollars as of 2019. The basis of the forex market is the fluctuations of exchange rates. Forex traders speculate on the price fluctuations of currency pairs, making money on the difference between buying and selling prices.</p>
            </div>
        </div>
      </div>
      <section className="bg-white" style={{paddingBottom: '8rem', paddingTop: '8rem'}}>
        <div className="container">
            <h1 className="mb-0 text-center fw-bold mb-4 text-black mx-auto" style={{maxWidth: '36rem'}}>No experience? No problem.</h1>
            <p className="text-center mx-auto mb-0 text-black mx-auto" style={{maxWidth: '36rem'}}>Our platform provides you with all the tools you need to earn, even as a complete beginner. From intuitive interfaces to real-time market insights and responsive customer support.</p>
            <div className="row my-5 py-4">
                <div className="col-lg-4 col-md-6 col-12">
                    <div className="d-flex">
                        <FontAwesomeIcon icon={faBolt} className="text-prime mt-1" style={{fontSize: '18px'}} />
                        <p className="mb-0 ms-3 text-black"><b>Instant Results.</b> Start seeing instant results with fully automated trading strategies, personal managers and trading guides.</p>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-12">
                    <div className="d-flex">
                        <FontAwesomeIcon icon={faLock} className="text-prime mt-1" style={{fontSize: '18px'}} />
                        <p className="mb-0 ms-3 text-black"><b>Secured.</b> Your assets are safe and secure with us, protected by the latest in cybersecurity measures and industry-standard protocols.</p>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-12">
                    <div className="d-flex">
                        <FontAwesomeIcon icon={faComment} className="text-prime mt-1" style={{fontSize: '18px'}} />
                        <p className="mb-0 ms-3 text-black"><b>Support. </b> Our representatives are available to assist you at anytime. Or reach us 24/7/365 on Live Chat or by email.</p>
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-center">
                <Link to="/account" state={{location : 'register'}} className="myBtn bg-prime px-4 py-2-5 rounded-5">Get started</Link>
            </div>
        </div>
      </section>
      <section style={{paddingTop: '8rem'}}>
        <div className="container">
            <h1 className="mb-0 text-center fw-bold mb-4 mx-auto" style={{maxWidth: '36rem'}}>Get started with trading today</h1>
            <p className="text-center mx-auto mb-4 mx-auto" style={{maxWidth: '36rem'}}>It’s easy to get started. Register an account with us and get started with trading today.</p>
            <div className="d-flex justify-content-center">
                <Link to="/account" state={{location : 'register'}} className="myBtn bg-prime px-4 py-2-5 rounded-5">Get started</Link>
            </div>
        </div>
      </section>
      <FrontFooter/>
    </div>
  )
}

export default Forex